// icons
import { MdCode, MdTableChart, MdDateRange, MdPages, MdDraw, MdAccountTree } from "react-icons/md";

const templates = {
    id: 'templates-group',
    type: 'group',
    roles: [1],
    breadcrumbs: false,
    children: [
      {
        id: 'templates',
        title: "Templates",
        type: 'collapse',
        icon: MdCode,
        children: [
          {
            id: 'table-list-standard',
            title: "Table List Standard",
            type: 'item',
            breadcrumbs: false,
            icon: MdTableChart,
            url: '/templates/table-list-standard'
          },
          {
            id: 'table-list-date-range',
            title: "Table List Date Range",
            type: 'item',
            breadcrumbs: false,
            icon: MdDateRange,
            url: '/templates/table-list-date-range'
          },
          {
            id: 'simple-page',
            title: "Simple Page",
            type: 'item',
            breadcrumbs: false,
            icon: MdPages,
            url: '/templates/simple-page'
          },
          {
            id: 'esignature',
            title: "Esignature",
            type: 'item',
            breadcrumbs: false,
            icon: MdDraw,
            url: '/templates/esignature'
          },
          {
            id: 'pruebas-diagrama',
            title: "Pruebas Diagrama",
            type: 'item',
            breadcrumbs: false,
            icon: MdAccountTree,
            url: '/templates/pruebas-diagrama'
          }
        ]
      }
    ]
  };

export default templates;
